import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — eneatipo 3. Portado de
 * `docs/canonical/Plantilla_maestra_nueve_eneatipos.docx`, Bloques A, B, D y E.
 *
 * En inglés, con el original español al lado de cada campo, igual que los
 * patrones 1, 6 y 9.
 *
 * Las marcas del canon se conservan: [PROPUESTA] es formulación del proyecto,
 * [LÍMITE] es un riesgo declarado, [FUENTE PROYECTO] viene de Vilaseca. Que
 * `shortHypothesis` sea [PROPUESTA] y no fuente externa importa: es la frase
 * que la persona lee como resultado.
 *
 * PARES: el Bloque E del 3 trata el 2 y el 4. El 1↔3 sale del lado del 1.
 */
export const PATTERN_3: Pattern = {
  id: "3",
  number: 3,
  // «el competidor» — Vilaseca: «el triunfador»
  workingName: "The achiever (working name)",
  // Patrón organizado alrededor del logro y la imagen de éxito como condición para sentirse valioso/a
  shortHypothesis:
    "A pattern organised around achievement and the image of success as the " +
    "condition for feeling worth something.",
  // Adicción al trabajo, desconexión emocional, dificultad para mostrar debilidad o fracaso
  whatItExplains:
    "Overwork, emotional disconnection, and difficulty showing weakness or " +
    "failure.",
  // Qué considera cada persona «éxito»; por qué alguien concreto prioriza el logro sobre otros valores
  whatItDoesNotExplain:
    "What any given person counts as success, or why one person puts " +
    "achievement above other values.",
  // [LÍMITE] Que la persona se defina solo por sus logros, y use la etiqueta para justificar seguir sin parar
  identityRisk:
    "Defining yourself only by what you achieve, and using the label to " +
    "justify not stopping.",
  confusablePatterns: ["1", "2", "4"],
  sourceRefs: [
    "Plantilla_maestra_nueve_eneatipos.docx, Eneatipo 3, Bloques A, B, D y E",
    "[LÍMITE] Vilaseca-céntrico: sin triangular contra una segunda fuente"
  ],
  contentVersion: "canon-nueve-1.0"
};
